import { Item } from '@react-stately/collections';
import { SelectionListItemCaption } from './components/SelectionListItemCaption/SelectionListItemCaption.js';
import { SelectionListItemContainer } from './components/SelectionListItemContainer/SelectionListItemContainer.js';
import { SelectionListItemIcon } from './components/SelectionListItemIcon/SelectionListItemIcon.js';
import { SelectionListItemImage } from './components/SelectionListItemImage/SelectionListItemImage.js';
import { SelectionListItemTitle } from './components/SelectionListItemTitle/SelectionListItemTitle.js';

var SelectionListItem = Item;
SelectionListItem.Image = SelectionListItemImage;
SelectionListItem.Caption = SelectionListItemCaption;
SelectionListItem.Container = SelectionListItemContainer;
SelectionListItem.Icon = SelectionListItemIcon;
SelectionListItem.Title = SelectionListItemTitle;

export { SelectionListItem };
//# sourceMappingURL=SelectionListItem.js.map
